import React, { forwardRef } from "react"
import styled from "styled-components"

const OneViewSVG = forwardRef((props, ref) => {
  return (
    <SVGWrapper ref={ref} width={props.width || 200} color={props.color} version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">
      <title>New Project</title>
      <path id="Layer 1" className="s0" d="m0 0h400v225h-400z"/>
      <g id="Folder 1 copy 3">
        <path id="Shape 1" className="s1" d="m13 21c0-3.3 2.7-6 6-6h278c3.3 0 6 2.7 6 6v152.7c0 3.3-2.7 6-6 6h-278c-3.3 0-6-2.7-6-6z"/>
        <path id="Shape 5 copy" className="s2" d="m192.6 90.7q2.4 2.3 2.4 5.3 0 3-2.4 5.3l-56 52.5q-2.4 2.2-5.6 2.2-3.3 0-5.6-2.2-2.4-2.3-2.4-5.3v-105q0-3 2.4-5.3 2.3-2.2 5.6-2.2 3.2 0 5.6 2.2l56 52.5z"/>
        <path id="Layer 3 copy 2" className="s1 browser-source" d="m318 21c0-3.3 2.7-6 6-6h59c3.3 0 6 2.7 6 6v153c0 3.3-2.7 6-6 6h-59c-3.3 0-6-2.7-6-6z"/>
        <g id="Folder 2 copy">
          <path id="Shape 2" className="s3" d="m326.3 30l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy" className="s3" d="m326.3 40l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 2" className="s3" d="m326.3 50l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 3" className="s3" d="m326.3 60l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 4" className="s3" d="m326.3 70l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 5" className="s3" d="m326.3 80l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 6" className="s3" d="m326.3 90l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 7" className="s3" d="m326.3 100l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 8" className="s3" d="m326.3 110l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 9" className="s3" d="m326.3 120l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 10" className="s3" d="m326.3 130l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 11" className="s3" d="m326.3 140l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 12" className="s3" d="m326.3 150l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 13" className="s3" d="m326.3 160l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 14" className="s3" d="m326.3 170l-0.1-5h53.8v5z"/>
        </g>
      </g>
    </SVGWrapper>
  )
})

export default OneViewSVG

const SVGWrapper = styled.svg`
  --color: ${props => props.color || '#fff'};
  .s0 { fill: none; stroke: var(--color); stroke-width: 10 }
  .s1 { fill: none; stroke: var(--color); stroke-width: 5 }
  .s2 { fill: var(--color); stroke: var(--color); stroke-width: 5 }
  .s3 { fill: var(--color) }

  .browser-source {
    stroke: var(--green-text);
    fill: var(--green-selected);
  }
`
